import React from 'react'
import './Me.css'

function Me(props) {
  return (
    <div className='about-me-container' id='about-section'>
      <h1>{props.title}</h1>
      <h3>{props.subtitle}</h3>
      <div className='statement-wrapper'>
      <p className='statement'>{props.statement[0]}</p>
<br></br>
<p className='statement'>
{props.statement[1]}
</p>
</div>

    </div>
  )
}

export default Me



// <h1>About Me</h1>
//       <h3>A Full Stack Developer and Technical Supprt Team Lead from Belfast, Ireland. Currently based in Vancouver BC, Canada</h3>
//       <div className='statement-wrapper'>
//       <p className='statement'>As a certified full stack developer, an experienced technical support professional and leader, I bring a strong foundation in technical troubleshooting, problem solving and leadership to the tech industry. Originally from Ireland, I moved to Canada in 2018 and am now a permanent resident. I made a move into Tech in 2019 where I was able to lead a Technical Support Team and continue my web development studies. I graduated from the Lighthouse labs web development course in May 2023.</p>
// <br></br>
// <p className='statement'>
// I have a passion for web development and enjoy building my own projects with HTML, CSS Javascript, JQuery, React, Express, PostgreSQL and Ruby. The fully responsive website you are currently viewing was coded by me from scratch using React 🧑‍💻
// I am confident that my experience in web development,  technical support and leadership will be an asset in the technical industry, and I am excited to take on new challenges.
// </p>
// </div>